module.exports = __webpack_public_path__ + "static/media/Miren-profile.240b9ede.jpg";